import React from "react";
import { string } from "prop-types";
import Image from "@insightfulscience/atomic-react/Image";

const PlasmidStaticMap = ({ src, siteDomain }) => (
	<Image isBaseUrl={false} src={`https://${siteDomain}${src}`} />
);

PlasmidStaticMap.propTypes = {
	src: string.isRequired,
	siteDomain: string.isRequired,
};

export default PlasmidStaticMap;
